// @flow

import * as React from 'react';
import {CaptionAlt, Text} from 'sail/Text';
import Group from 'sail/Group';
import {CompactTooltip} from 'sail/Tooltip';
import Icon from 'sail/Icon';

import type {IconType} from 'sail/Icon';

type Props = {
  label?: React.Node,
  icon?: IconType,
  tip?: string,
  onClick: (e: MouseEvent) => void,
};

const StripeCluiButtonLink = ({
  label,
  icon,
  tip,
  onClick,
}: Props): React.Node => {
  const buttonLink = (
    <button className="StripeCluiButtonLink" onClick={onClick} type="button">
      <Group direction="horizontal" spacing={4} alignItems="center">
        {!!icon && <Icon color="inherit" icon={icon} size={label ? 10 : 16} />}
        {!!label && <CaptionAlt color="inherit">{label}</CaptionAlt>}
      </Group>
    </button>
  );

  return tip ? (
    <CompactTooltip
      variableWidth
      context={buttonLink}
      label={
        <Text wrap={false} color="inherit">
          {tip}
        </Text>
      }
    />
  ) : (
    buttonLink
  );
};

export default StripeCluiButtonLink;
